import type { LockGuardWidget } from '../../../widgets';
import {
  BindingRow,
  NumberField,
  Row,
  ScalarField,
  Section,
  TextField,
  patcher,
  type WidgetEditorProps,
} from '../fields';

/** Freigabe-Riegel.
 *
 *  Die Zeit ist hier das Wesentliche: ohne Bestaetigung faellt die Freigabe
 *  von selbst zurueck, damit ein vergessener Handbetrieb nicht ueber das
 *  Wochenende stehen bleibt. */
export function LockGuardEditor(
  { widget, plantId, onChange }: WidgetEditorProps<LockGuardWidget>,
) {
  const patch = patcher(widget, onChange);
  return (
    <>
      <Section title="Bindung">
        <BindingRow
          label="Befehls-Datenpunkt"
          value={widget.commandPoint}
          plantId={plantId}
          filter={{ writable: true }}
          onChange={(next) => patch({ commandPoint: next })}
        />
        <BindingRow
          label="Rückmelde-Datenpunkt"
          value={widget.feedbackPoint}
          plantId={plantId}
          onChange={(next) => patch({ feedbackPoint: next })}
        />
      </Section>
      <Section title="Freigabe">
        <Row>
          <ScalarField
            label="Wert zum Freigeben"
            value={widget.armValue}
            required
            onChange={(next) => patch({ armValue: next })}
          />
          <ScalarField
            label="Wert zum Sperren"
            value={widget.disarmValue}
            required
            onChange={(next) => patch({ disarmValue: next })}
          />
        </Row>
        <NumberField
          label="Rückfall nach"
          unit="s"
          value={widget.timeoutSeconds}
          min={1}
          integer
          onChange={(next) => patch({ timeoutSeconds: next })}
        />
        <Row>
          <TextField
            label="Beschriftung Freigeben"
            value={widget.armLabel}
            placeholder="Freigeben"
            onChange={(next) => patch({ armLabel: next })}
          />
          <TextField
            label="Beschriftung Sperren"
            value={widget.disarmLabel}
            placeholder="Sperren"
            onChange={(next) => patch({ disarmLabel: next })}
          />
        </Row>
        <TextField
          label="Text der Rückfrage"
          value={widget.confirmationCopy}
          placeholder="Handbetrieb hebt die Regelung auf. Weiter?"
          hint="Steht im Dialog und wird mit dem Schreibvorgang protokolliert."
          onChange={(next) => patch({ confirmationCopy: next })}
        />
      </Section>
    </>
  );
}
